/**
*
* LandingMenuBarSemplificato
*
*/

import styled, { css } from 'styled-components';

import { ContainerFlex } from '../Blocks';

import media from '../../style/mediainjector';

export const ClearLink = styled.a`
  color: inherit;
  display: inherit;
  text-decoration: inherit;
  cursor: pointer;
`;

export const MenuBar = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 72px;
  backdrop-filter: saturate(180%) blur(16px);
  background-color: rgba(255,255,255,0.9);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  z-index: 8;
  ${media.gt667`
    ${({ start }) => start > 0 && css`
      height: 96px;
      box-shadow: none;
      background-color: ${(props) => (props.bgStartColor)};
    `}
  `}
  transition: all 0.3s;
  * {
  transition: all 0.3s;
  }
  ${media.print`
      display: none;
  `}
`;

export const LandingMenu = styled(ContainerFlex)`
  height: 100%;
  color: ${(props) => (props.color ? props.color : props.theme.brand)};
  justify-content: space-between;
  ${media.mobile`
    padding: 0 40px;
  `}
  ${media.lt667`
    padding: 0 20px;
  `}
`;

// TODO: capire come testare montando il router
export const BarMenuItem = styled.span`
  color: ${(props) => props.color};
  font-size: 18px;
  display: inline-block;
  text-decoration: none;
  padding: 2px 12px 3px;
  margin: 0 2px;
  background-image:none;
  cursor: pointer;
  border-radius: 100px;
  border: 1px solid ${({ theme: { brand } }) => (brand || 'rgb(240, 240, 240)')};
  a, a:visited {
    color: ${(props) => props.theme.brand};
  }
  &:last-child {
    margin-right: 0;
    display: none;
  }
  ${({ start }) => start && css`
    &:last-child {
      display: inline-block;
      padding: 2px 16px 3px;
    }
    &:last-child:not(:only-child) {
      border: 1px solid ${(props) => props.theme.brand};
    }
  `}
  ${({ activeLink }) => activeLink && css`
    color: ${(props) => (props.mainBg ? props.mainBg : props.theme.brand)};
    border: none;
    pointer-events: none;
    font-weight: 800;
    a, a:visited {
      color: ${(props) => (props.mainBg ? props.mainBg : props.theme.brand)};
    }
  `}
`;

export const CTAButton = styled.a`
  display: block;
  color: rgb(255,255,255);
  font-weight: 600;
  padding: 12px 14px;
  background-color: ${(props) => props.theme.brand};
  border-radius: 12px;
  border: none;
  box-shadow: 0 0 4px 1px rgba(0,0,0,0.20);
  ${({ start }) => start && css`
    display: none;
  `}
  ${media.gt667`
    padding: 12px 24px;
  `}
  text-decoration: none;
`;
